import { useEffect } from 'react';
var setShortLink = function setShortLink(shortenedLink, shortenType, setUrlToCopy) {
  useEffect(function () {
    if (shortenedLink) {
      sessionStorage.setItem(shortenType, shortenedLink);
      setUrlToCopy(shortenedLink);
    }
  }, [shortenedLink]);
};
export default setShortLink;